import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full tuning-preset-selector" }
const _hoisted_2 = {
  key: 0,
  class: "text-white"
}
const _hoisted_3 = { class: "pr-3" }
const _hoisted_4 = { key: 0 }

import AccidedPname from '@/components/utils/signs/AccidedPname.vue';
import { TTuningPreset } from '@/store/modules/db-types';
import RezTabFile from '@/store/modules/RezTabFile';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';

export default /*@__PURE__*/_defineComponent({
  __name: 'TuningPresetSelector',
  props: {
    staffIndex: {}
  },
  emits: ['addStaffLine', 'removeStaffLine'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const presets = ref<TTuningPreset[]>();
const chosenPreset = ref<TTuningPreset>(presets.value?.[0] || {});
onMounted(async () => {
    presets.value = (await axios.get(useStore().state.apiUrl + '/retab/tuning-presets')).data;
    

})
const store = useStore();
async function setTuning(tuningPreset: TTuningPreset) {
    const doc = store.state.currentDoc as RezTabFile;
    const oldLength = doc.section.info.staves[props.staffIndex].tuning?.length;
    const newLength =  tuningPreset.tuning?.length;

    
    tuningPreset.tuning?.forEach(course => {
        const found = doc.section.info.staves[props.staffIndex].tuning?.find(staffLineTuning => staffLineTuning.n == course.n);
        if (found) {
            found.pname = course.pname;
            found.oct = course.oct
        } else {
            emits('addStaffLine', course)
        }

    })
    if ((oldLength || 0) - (newLength||0) > 0) {
        
        for (const courseTuning of doc.section.info.staves[props.staffIndex].tuning?.slice(newLength) || [])  {
            emits('removeStaffLine', props.staffIndex, courseTuning.n)
        }
    }

    

}



return (_ctx: any,_cache: any) => {
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_va_select, {
      label: "preset",
      color: "white",
      options: presets.value,
      modelValue: chosenPreset.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((chosenPreset).value = $event)),
        setTuning
      ],
      "text-by": "title",
      class: "w-full min-w-52 my-3"
    }, {
      "option-content": _withCtx(({ option }) => [
        option
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createTextVNode(_toDisplayString((option as unknown as TTuningPreset).title!) + " ", 1),
                ((option as  unknown as TTuningPreset).title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, ":"))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((option as unknown as TTuningPreset).tuning, (course) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: course.n
                }, [
                  _createVNode(AccidedPname, {
                    pname: course.pname
                  }, null, 8, ["pname"]),
                  _createElementVNode("sub", null, _toDisplayString(course.oct), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "px-2" }, "|", -1))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["options", "modelValue"])
  ]))
}
}

})